<template>
  <sn-select
    class="sn-select-wrapper"
    :class="{
      'open': open,
      'approved': data.isValid === true,
      'alert': data.hasAlert,
      'invalid': data.isValid === false
    }"
    :display-type="propertyData.displayType"
    :disabled="disabled"
    :options="options"
    :active-options="initialOptions"
    :label="label"
    :label-key="label"
    :settings="propertyData"
    :selection-width="width"
    :subtitle-key="propertyData.subtitleKey"
    @selectionChanged="updateValue"
    @isOpen="updateOpen"
  />
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'

export default {
  name: 'SNSelectWrapper',
  components: {
  },
  props: {
    settings: {
      default: function () {
        return {
          'singleSelect': false,
          'activeOptions': null,
          'placeHolder': '',
          'displayColor': false,
          'displayType': 'default',
          'subtitleKey': 'Email'
        }
      },
      type: Object
    },
    label: {
      default: 'name',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    width: {
      default: 600,
      type: Number
    },
    data: {
      default: function () {
        return {}
      },
      type: Object
    },
    item: {
      default: function () {
        return {}
      },
      type: Object
    },
    property: {
      default: '',
      type: String
    },
    options: {
      default: function () {
        return []
      },
      type: Array
    },
    readonly: Boolean
  },
  data () {
    return {
      localOptions: [],
      isFocused: false,
      showDebugLogs: false,
      open: false
    }
  },
  computed: {
    propertyData () {
      let self = this
      let result = _.cloneDeep(self.settings)

      // sets values based on data if not available in settings
      result.singleSelect = self.singleSelect
      result.displayColor = self.displayColor
      result.placeHolder = self.placeHolder
      result.leftIcon = self.leftIcon
      result.identifier = self.identifier
      result.tall = self.tall

      return result
    },
    propertyDataActiveOptions () {
      let self = this
      let result = false

      if (self.settings && self.settings.activeOptions) {
        result = _.filter(self.settings.activeOptions, { 'selected': true })
      }

      return result
    },
    singleSelect () {
      let self = this
      let result = false

      if (self.settings) {
        result = self.settings.singleSelect ? self.settings.singleSelect : self.data.identifier
      }

      return result
    },
    displayColor () {
      let self = this
      let result = false

      if (self.settings && self.settings.displayColor) {
        result = self.settings.displayColor
      }
      return result
    },
    hasOptions () {
      let self = this
      return _.size(self.options) > 0
    },
    initialOptions () {
      let self = this
      let result = []

      // prioritise propertyData activeOptions, otherwise filter options on selected = true
      if (self.propertyDataActiveOptions) {
        result = self.propertyDataActiveOptions
      } else {
        // if we have no active options, determine them from the "selected" property.
        result = _.filter(self.options, { 'selected': true })
      }

      return result
    },
    placeHolder () {
      let self = this
      let result = self.settings.placeHolder ? self.settings.placeHolder : self.data.placeHolder
      return result
    },
    leftIcon () {
      let self = this
      let result = ''

      if (self.settings) {
        result = self.settings.leftIcon ? self.settings.leftIcon : self.data.leftIcon
      }

      return result
    },
    identifier () {
      let self = this
      let result = ''

      if (self.settings) {
        result = self.settings.identifier ? self.settings.identifier : self.data.identifier
      }

      return result
    },
    tall () {
      let self = this
      let result = ''

      if (self.settings) {
        result = self.settings.tall ? self.settings.tall : self.data.tall
      }

      return result
    }
  },
  methods: {
    updateValue (optionSelection) {
      let self = this

      let selectionArray = []

      if (_.size(optionSelection) > 0) {
        if (self.singleSelect) {
          let objArray = _.filter(optionSelection)
          objArray[0].selected = true
        }

        let filteredOptions = _.filter(optionSelection, { 'selected': true })
        selectionArray = _.map(filteredOptions, function (option) {
          if (option[self.identifier]) {
            return option[self.identifier]
          } else {
            if (self.showDebugLogs) {
              // console.error('Identifier not found! ' + self.identifier)
            }
            return null
          }
        })
      }

      self.$emit('changed', {
        property: self.property,
        value: selectionArray
      })
    },
    updateOpen (newValue) {
      let self = this
      self.open = newValue
    }
  },
  watch: {
    initialOptions: {
      handler: function () {
      }
    },
    item: {
      handler: function () {
      },
      immediate: true,
      deep: true
    },
    options: {
      handler: function (val) {
        let self = this
        _.forEach(val, f => {
          if (f.selected !== true) {
            f.selected = false
          }
        })
        Vue.set(self, 'localOptions', val)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../kit-components/uikit';

  .sn-select-wrapper {
    border: 1px solid $primaryBorderColor;
    cursor: pointer;
    height: 50px;

    &.alert {
      border-color: $alertOrange;
    }
    &.approved {
      border-color: $approvedGreen;
    }
    &.invalid {
      border-color: $errorRed;
    }
    &.open {
      border-color: $pendingBlue;
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/components/Inputs/Selection/SNSelectWrapper.vue